<template>
  <div>
    <div class="text-muted small">{{activity.created_at | formatRelativeDate}}</div>
    <!--USER LINK-->
    <UserLink :user="activity.causer"/>

    <!--ACTIVITY LOG ACTION-->
    {{ $t('actions.' + $options.filters.slugify(activity.description)) }}

    <!--CREATED-->
    <div v-if="activity.description === 'added'">

      <div v-if="activity.subject">
        <span>{{makeTitle(activity.properties.type) | lowerCase}}</span>
        <span> {{ $t('validations.log.title') | lowerCase}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('activities.log.title') }}</span>
        <router-link
                :to="{ name: 'activities.view', params: { slug: activity.subject.relation.slug }}"
        >
            {{activity.properties.relation.name}}
        </router-link>
      </div>

      <div v-else>
        <span>{{makeTitle(activity.properties.type) | lowerCase}}</span>
        <span> {{ $t('validations.log.title') | lowerCase}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('activities.log.title') }}</span>
        <router-link
                :to="{ name: 'activities.view', params: { slug: activity.properties.relation.slug }}"
        >
            {{activity.properties.relation.name}}
        </router-link>
      </div>

      <div v-if="changes">
        <div v-if="activity.properties.validation && activity.properties.validation === 1" class="mt-2">
          <font-awesome-icon icon="check-circle" class="icon-success"/>
          {{ $t('system.approved') }}
          <span class="ml-3">
            <font-awesome-icon icon="comment"/>
            {{activity.properties.comment}}
          </span>
        </div>
        <div v-else class="mt-2">
          <font-awesome-icon icon="times-circle" class="icon-danger"/>
          {{ $t('system.rejected') }}
          <span class="ml-3">
            <font-awesome-icon icon="comment"/>
            {{activity.properties.comment}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';

  export default {
    name: 'ActivityValidation',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0
      }
    },
    props: {
      activity: {},
      changes: false
    },
    components: {
      UserLink
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }

        }

        return words.join(' ');
      }
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
